var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-header"},[_c('img',{staticClass:"logo",attrs:{"src":require('@/assets/image/logo.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }